// redux/allReducer/tenantPlanReducer.js
import {
  SET_TENANT_PLAN,
  FETCH_TENANT_PLAN_REQUEST,
  FETCH_TENANT_PLAN_SUCCESS,
  FETCH_TENANT_PLAN_FAILURE
} from '../allAction/tenantPlanActions';

const initialState = {
  data: null,
  loading: false,
  error: null,
  shouldRefetch: false,
  lastFetched: null
};

const tenantPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TENANT_PLAN:
      return {
        ...state,
        data: action.payload,
        shouldRefetch: false,
        error: null
      };

    case FETCH_TENANT_PLAN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_TENANT_PLAN_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
        lastFetched: Date.now(),
        shouldRefetch: false
      };

    case FETCH_TENANT_PLAN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        shouldRefetch: true
      };

    default:
      return state;
  }
};

export default tenantPlanReducer;